import { useApiGet, useApiPatch } from '@sierralabs/core-ui';
export function useFindFormSchemas() {
    const { data, isLoading, error, get } = useApiGet('form-schemas');
    return {
        formSchemaList: data,
        isLoading,
        loadingError: error,
        findFormSchemas: get
    };
}
export function useFindFormSchemaData(id) {
    const { data, isLoading, error, get } = useApiGet(`form-schemas/${id}/data`);
    return {
        formDataList: data,
        isLoading,
        loadingError: error,
        getFormData: get
    };
}
export function useFindFormSchemaDeltas(id) {
    const { data, isLoading, error, get } = useApiGet(`form-schemas/${id}/deltas`);
    return {
        formSchemaDeltaList: data,
        isLoading,
        loadingError: error,
        getFormSchemaDeltas: get
    };
}
export function useApplyFormSchemaDelta(id) {
    const { data, isLoading, error, patch } = useApiPatch(`form-schemas/${id}/deltas`);
    return {
        updatedResult: data,
        isUpdating: isLoading,
        updateError: error,
        applyFormSchemaDeltas: patch
    };
}
//# sourceMappingURL=FormSchema.hooks.js.map